export default __webpack_public_path__ + "static/media/successIcon.08da0ff7.svg";